(() => {
  const initialize = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    root.querySelectorAll('[data-open-support]').forEach(link => link.addEventListener('click', () => {
      root.querySelector('[data-support-form]').open = true;
    }));
    const input = root.querySelector('[data-faq-search]');
    const items = [...root.querySelectorAll('[data-group]')];
    const headings = [...root.querySelectorAll('[data-heading]')];
    const links = [...root.querySelectorAll('[data-category]')];
    const status = root.querySelector('[data-faq-status]');
    const clear = root.querySelector('[data-clear]');
    const answerContainer = root.querySelector('.th-faq-answers');
    const originalAnswerNodes = [...answerContainer.children];
    const video = root.querySelector('.th-faq-video');
    const library = root.querySelector('.th-faq-library');
    const searchWrap = root.querySelector('[data-search-wrap]');
    const feedback = document.createElement('p');
    feedback.className = 'th-faq-search-feedback';
    feedback.setAttribute('role', 'status');
    feedback.setAttribute('aria-live', 'polite');
    feedback.hidden = true;
    searchWrap.append(feedback);
    input.setAttribute('enterkeyhint', 'search');
    input.setAttribute('aria-controls', library.id);
    library.setAttribute('tabindex', '-1');
    const watchLink = root.querySelector('.th-faq-quick a');
    watchLink.addEventListener('click', () => { video.hidden = false; });
    let category = 'all';
    const normalized = text => text.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g,'');
    const filter = () => {
      const terms = normalized(input.value.trim()).split(/\s+/).filter(Boolean);
      root.classList.toggle('th-faq-searching', terms.length > 0);
      video.hidden = terms.length > 0;
      if (video.hidden) video.querySelector('video')?.pause();
      const shippingSearch = terms.some(term => /^(shipping|ship|ships|delivery)$/.test(term));
      const priorityQuestions = ['how fast is shipping?', 'where does it ship from?'];
      const priorityItems = priorityQuestions.map(question => items.find(item => normalized(item.querySelector('summary').childNodes[0].textContent.trim()) === question)).filter(Boolean);
      originalAnswerNodes.forEach(node => answerContainer.append(node));
      if (shippingSearch && priorityItems.length) {
        const group = priorityItems[0].dataset.group;
        const heading = headings.find(node => node.dataset.heading === group);
        const groupItems = items.filter(item => item.dataset.group === group && !priorityItems.includes(item));
        const groupNodes = [heading, ...priorityItems, ...groupItems].filter(Boolean);
        const firstHeading = answerContainer.querySelector('[data-heading]');
        groupNodes.forEach(node => answerContainer.insertBefore(node, firstHeading));
      }
      let count = 0;
      items.forEach(item => {
        const match = (category === 'all' || item.dataset.group === category) && terms.every(term => normalized(item.textContent).includes(term) || (shippingSearch && priorityItems.includes(item) && /^(shipping|ship|ships|delivery)$/.test(term)));
        item.hidden = !match;
        if (match) count++;
        item.open = terms.length > 0 && match;
      });
      headings.forEach(heading => {heading.hidden = !items.some(item => item.dataset.group === heading.dataset.heading && !item.hidden);});
      links.forEach(link => link.setAttribute('aria-current', String(link.dataset.category === category)));
      clear.hidden = !input.value;
      status.hidden = !terms.length && category === 'all';
      status.textContent = `${count} ${count === 1 ? 'answer' : 'answers'}${terms.length ? ` for “${input.value.trim()}”` : ''}`;
      feedback.hidden = !terms.length;
      feedback.textContent = terms.length ? `${count} ${count === 1 ? 'answer' : 'answers'} found below. Press Enter to view results.` : '';
      root.querySelector('[data-faq-empty]').hidden = count !== 0;
    };
    root.querySelector('[data-search-wrap]').hidden = false;
    input.addEventListener('input', () => { category = 'all'; filter(); });
    input.addEventListener('keydown', event => {
      if (event.key !== 'Enter' || event.isComposing) return;
      event.preventDefault();
      if (!input.value.trim()) return;
      filter();
      feedback.textContent = status.textContent;
      library.focus({preventScroll:true});
      library.scrollIntoView({behavior:'instant',block:'start'});
    });
    clear.addEventListener('click', () => {input.value='';items.forEach(item=>item.open=false);filter();input.focus();});
    links.forEach(link => link.addEventListener('click', event => {
      event.preventDefault();category=link.dataset.category;input.value='';items.forEach(item=>item.open=false);filter();
      root.querySelector('.th-faq-library').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    }));
    root.addEventListener('shopify:block:select', event => {
      category='all';input.value='';filter();
      const item=event.target.closest('details');if(item)item.open=true;
    });
  };
  document.querySelectorAll('[data-faq-hub]').forEach(initialize);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-faq-hub]').forEach(initialize));
})();
